export const TitleEN = [
  {
    id: 1,
    text: 'Hi,'
  },
  {
    id: 2,
    text: `I'm, Jonathan Araujo`
  },
  {
    id: 3,
    text: 'JavaScript Developer'
  }
];

export const TitleES = [
  {
    id: 1,
    text: 'Hola,'
  },
  {
    id: 2,
    text: 'Soy, Jonathan Araujo'
  },
  {
    id: 3,
    text: 'Desarrollador JavaScript'
  }
];

export const menuOptsEN = [
  {
    id: 1,
    name: 'HOME',
    link: '#home'
  },
  {
    id: 2,
    name: 'ABOUT ME',
    link: '#about-me'
  },
  {
    id: 3,
    name: 'CARRER',
    link: '#carrer'
  },
  {
    id: 4,
    name: 'CONTACT ME',
    link: '#contact-me'
  }
];

export const menuOptsES = [
  {
    id: 1,
    name: 'INICIO',
    link: '#home'
  },
  {
    id: 2,
    name: 'SOBRE MI',
    link: '#about-me'
  },
  {
    id: 3,
    name: 'CARRERA',
    link: '#carrer'
  },
  {
    id: 4,
    name: 'CONTACTAME',
    link: '#contact-me'
  }
];

export const languagesOpts = [
  {
    id: 1,
    flag: '/images/icons/united-kingdom-flag.png',
    alt: 'united-kingdom-flag',
    value: 'EN'
  },
  {
    id: 2,
    flag: '/images/icons/spain-flag.png',
    alt: 'spain-flag',
    value: 'ES'
  }
];
